import { Typography } from '@mui/material'
import type { FieldProps } from '@rjsf/utils'
import { Suspense, lazy } from 'react'
import { useTranslation } from 'react-i18next'

const RALSelector = lazy(
  () => import('components/RALSelector/RALColorSelector'),
)

type PowderCoatingDto = {
  colorCode?: string
  [key: string]: unknown
}

export const RalSelectorField = (props: FieldProps) => {
  const { t } = useTranslation()
  const { fieldPathId, formData, onChange, schema } = props
  const isObjectField = schema.type === 'object'
  const powderCoating = isObjectField ? (formData as PowderCoatingDto) : null

  const selectedRALId = isObjectField
    ? (powderCoating?.colorCode ?? '')
    : ((formData as string | undefined) ?? '')
  const colorCodePath = isObjectField
    ? [...fieldPathId.path, 'colorCode']
    : fieldPathId.path

  return (
    <Suspense
      fallback={
        <Typography
          variant="caption"
          style={{ alignSelf: 'center', marginTop: '1em' }}
        >{`${t('common:loading')}...`}</Typography>
      }
    >
      <RALSelector
        selectedRALId={selectedRALId}
        onRALIdSelected={(ralId) => {
          onChange(ralId, colorCodePath)
        }}
        size="small"
        label={t(`${props.uiSchema['ui:label-translation-key']}`, {
          ns: 'project',
        })}
        inputProps={{
          style: {
            padding: '2px 0 2px 0',
            fontSize: '12px',
          },
        }}
      />
    </Suspense>
  )
}
